
import { gql } from "apollo-boost"

export const createCommentsVisitsAndDeliverables = gql`
  mutation CreateFieldsVisitAndDeliverablesComments(
    $visitsAndDeliverablesComment: ID!, 
    $data: CreateMonitoringCommentInput!
  ){
    CreateFieldsVisitAndDeliverablesComments(
      visitsAndDeliverablesComment: $visitsAndDeliverablesComment
      data: $data
    ){
      id
    }
  }
`